import { Dialog, DialogContent, DialogTitle } from "@mui/material"
import PlayerEventsList from "./PlayerEventsList"

const PlayerEventsDialog = ({ open, onClose, playerEvent, storageKey }) => (
    <Dialog
        sx={{
            "& .MuiDialog-paper": {
                minHeight: "300px",
                maxHeight: "80vh"
            }
        }}
        fullWidth
        maxWidth="md"
        open={open}
        onClose={onClose}
    >
        <DialogTitle>
            {playerEvent && (playerEvent?.eventType ?? playerEvent.eventId)}
        </DialogTitle>
        <DialogContent>
            {playerEvent && <PlayerEventsList playerEvent={playerEvent} storageKey={storageKey} />}
        </DialogContent>
    </Dialog>
)

export default PlayerEventsDialog
